import React, { useRef } from 'react'
import { useSelector } from 'react-redux'

import { useOutcomeTrafficCampaign } from './hooks/useOutcomeTrafficCampaign'
import { useOutcomeAppPromotionCampaign } from './hooks/useOutcomeAppPromotionCampaign'

import { lineItemsSelector } from '../../../../../modules/selectors/lineItems'
import { facebookRightUploadAdCampaignSelector } from '../../../../../modules/selectors/rights'
import { selectedFacebookAdAccountSelector } from '../../../../../modules/selectors/adAccounts'

export const LineItemFormContext = React.createContext()

export const LineItemFormContextProvider = ({ children }) => {
  const lineItems = useSelector(lineItemsSelector)
  const campaign = useSelector(facebookRightUploadAdCampaignSelector)
  const { id: facebookAdAccountId } = useSelector(selectedFacebookAdAccountSelector)

  // use ref to avoid reset, when a new line item is created and line items are updated
  const isFirstLineItemCreationRef = useRef(lineItems?.length === 0)
  const isFirstLineItemCreation = isFirstLineItemCreationRef.current

  const { objective: campaignObjective, id: campaignId } = campaign

  const {
    preselectedValues,
    showPromotedObjectStepForTrafficCampaign,
    isDataLoading: isTrafficCampaignDataLoading
  } = useOutcomeTrafficCampaign({ campaignId, facebookAdAccountId, campaignObjective, isFirstLineItemCreation })
  const {
    showPromotedObjectStepForAppPromotionCampaign,
    isDataLoading: isAppPromotionCampaignDataLoading,
    isIos14Campaign
  } = useOutcomeAppPromotionCampaign({ facebookAdAccountId, campaignId, campaignObjective })

  const isDataLoading = isTrafficCampaignDataLoading || isAppPromotionCampaignDataLoading

  return (
    <LineItemFormContext.Provider
      value={{
        isDataLoading,
        isIos14Campaign,
        preselectedValues,
        showPromotedObjectStepForTrafficCampaign,
        showPromotedObjectStepForAppPromotionCampaign
      }}
    >
      {children}
    </LineItemFormContext.Provider>
  )
}
